import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ResetPasswordService {
    private apiURL = `${environment.apiUrl}/api/ResetPassword`;

    constructor(private http: HttpClient) { }

    resetPassword(username: string, email: string): Observable<string> {
        const url = `${this.apiURL}/resetPassword`;
        return this.http.post(url, { username: username, email: email }, { responseType: 'text' as const })
            .pipe(
                tap(_ => this.log('Reset Password Email sent')),
                catchError(this.handleError<string>('resetPassword'))
            );
    }

    changePassword(username: string, password: string): Observable<boolean> {
        const url = `${this.apiURL}/changePassword`;
        return this.http.post<boolean>(url, { username: username, password: password })
            .pipe(
                catchError(this.handleError<boolean>('changePassword'))
            );
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    private log(message: string) {
        console.log(message);
    }

}